import * as XLSX from "xlsx";

export interface ExportOptions {
  fileName?: string;
  sheetName?: string;
}

/**
 * Exports data to an Excel file
 * @param data - Array of objects to export
 * @param columns - Array of column definitions with field and header
 * @param options - Export options (fileName, sheetName)
 */
export function exportToExcel<T>(
  data: T[],
  columns: Array<{ field?: string; header?: string }>,
  options: ExportOptions = {},
) {
  const { fileName = "export.xlsx", sheetName = "Sheet1" } = options;

  // Transform data to match column headers
  const transformedData = data.map((row) => {
    const newRow: Record<string, unknown> = {};
    for (const col of columns) {
      if (col.field && col.header) {
        const keys = col.field.split(".");
        let value: unknown = row;

        // Handle nested properties like "author.lastname"
        for (const key of keys) {
          if (value !== null && typeof value === "object" && key in value) {
            value = (value as Record<string, unknown>)[key];
          } else {
            value = undefined;
            break;
          }
        }

        newRow[col.header] = value ?? "";
      }
    }

    return newRow;
  });

  // Create workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(transformedData);

  // Auto-adjust column widths
  const columnWidths = columns.map((col) => ({
    wch: (col.header?.length ?? 10) + 2,
  }));
  worksheet["!cols"] = columnWidths;

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Trigger download
  XLSX.writeFile(workbook, fileName);
}
